import { useState } from 'react'
import * as XLSX from "xlsx-js-style"

const useExportExcel = () => {

  const [isLoading, setIsLoading] = useState(false);

  function exportExcel({ data, cols, hasNumber = false }) {
    console.log(data)

    const sheetData = data.map((value) => {

      return Object.fromEntries(cols.map(el => ([
        el.label, value[el.key]
      ])))
    })

    console.log(sheetData)
    const ws = XLSX.utils.json_to_sheet(sheetData);

    console.log(cols.map(el => ({ wch: el.width })))
    const wscols = cols.map(el => ({ wch: el.width }))
    ws['!cols'] = wscols;

    const borderStyle = {
      style: "thin",
      color: { rgb: "000000" }
    };

    const borders = {
      top: borderStyle,
      bottom: borderStyle,
      left: borderStyle,
      right: borderStyle
    };

    // Style header row first
    cols.forEach((key, colIdx) => {
      const headerCellRef = XLSX.utils.encode_cell({ r: 0, c: colIdx });
      ws[headerCellRef] = {
        v: key.label,
        t: 's',
        s: {
          font: {
            bold: true,
            color: { rgb: "FFFFFF" }
          },
          fill: {
            fgColor: { rgb: "2075B3" }
          },
          alignment: {
            vertical: "center",
            horizontal: "center",
            wrapText: true
          },
          borders
        }
      };
    });

    data.forEach((row, rowIdx) => {
      cols.forEach((key, colIdx) => {

          const cellRef = XLSX.utils.encode_cell({ r: rowIdx + 1, c: colIdx });
          const value = row[key.key];

          // Base style with word wrap
          let style = {
              alignment: {
                  vertical: "center",
                  horizontal: "left",
                  wrapText: true // Enable word wrap
              }
          };

          ws[cellRef] = {
              v: value,
              t: typeof value === 'number' ? 'n' : 's', // 'n' for numbers, 's' for strings
              s: style
          };
      });
  });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Dataset Intent");

    XLSX.writeFile(wb, "Dataset intent.xlsx")
  }

  return { exportExcel, isLoading }
}

export default useExportExcel